import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionTitle from "../../SectionTitle";

const ImageContent = ({
  data,
  titleProps = {
    position: "section",
    className: "",
    color: "secondary",
    hide: false,
  },
  imagePosition = "left",
  containerClassName = "",
  contentContainerClassName = "lg:w-1/2 lg:basis-1/2 px-4 lg:px-8",
  imageContainerClassName = "lg:w-1/2 lg:basis-1/2",
}) => {
  const {
    title,
    image,
    content,
    buttons = [],
    imagePosition: _imagePosition,
  } = data || {};
  const imageData = image
    ? getImage(image?.localFile?.childImageSharp?.gatsbyImageData)
    : null;

  const imgPosition = _imagePosition || imagePosition;

  const isVertical = imgPosition === "top" || imgPosition === "bottom";
  const isLeft = imgPosition === "left";
  // const isRight = imgPosition === "right";

  return (
    <>
      {/* Top-positioned section title */}
      {titleProps?.position === "top" && !titleProps?.hide && (
        <SectionTitle
          title={title}
          color={titleProps?.color}
          weight="bold"
          className={`mb-6 ${titleProps?.className}`}
        />
      )}

      <div className={`flex flex-wrap ${containerClassName}`}>
        {/* Image on top */}
        {imgPosition === "top" && imageData && (
          <div className="mb-6 w-full basis-full px-4">
            <GatsbyImage image={imageData} alt="" />
          </div>
        )}

        {/* Content */}
        <div
          className={`w-full basis-full px-4 ${
            !isVertical
              ? `${
                  isLeft ? "lg:order-2" : "lg:order-none"
                } ${contentContainerClassName}`
              : ""
          }`}
        >
          {titleProps?.position === "section" && !titleProps?.hide && (
            <SectionTitle
              title={title}
              color={titleProps?.color}
              weight="bold"
              className={`mb-6 ${titleProps?.className}`}
            />
          )}

          <div
            className="mb-6 font-openSans text-lg text-black 2xl:text-xl"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>

          {buttons?.length > 0 && (
            <div className="mb-6 flex flex-wrap gap-3">
              {buttons?.map((button, index) => (
                <a
                  href={button?.buttonData?.url}
                  target={button?.buttonData?.target}
                  key={index}
                  className={`inline-block rounded-xl px-12 py-2 text-white transition-all duration-500 ${
                    button.blueButton
                      ? "bg-primary hover:bg-secondary"
                      : "bg-secondary hover:bg-primary"
                  }`}
                >
                  {button?.buttonData?.title}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Image: left, right, or bottom */}
        {imageData && !isVertical && (
          <div
            className={`w-full basis-full px-4 ${
              isLeft ? "lg:order-1" : "lg:order-none"
            } ${imageContainerClassName}`}
          >
            <GatsbyImage image={imageData} alt="" />
          </div>
        )}

        {/* Image on bottom */}
        {imgPosition === "bottom" && imageData && (
          <div className="mt-6 w-full basis-full px-4">
            <GatsbyImage image={imageData} alt="" />
          </div>
        )}
      </div>
    </>
  );
};

export default ImageContent;
